import { parsePageFieldToDate, type ParsePageFieldToDateOptions } from './parsePageFieldToDate'
import {
  resolveDateTimePickerProps,
  type DateTimePickerProps,
} from './resolveDateTimePickerProps'
import { formatDate } from './date'

const MASK_PLACEHOLDER = '_'

export function parseApplyCurrentDateOnClick(
  node: { _text?: string } | string | undefined | null,
): boolean {
  if (node == null) return false
  const t =
    typeof node === 'string' ? node.trim() : String(node._text ?? '').trim()
  if (!t) return false
  const lower = t.toLowerCase()
  return lower === 'true' || lower === '1' || lower === 'yes'
}

/** Java SimpleDateFormat → tokens supported by formatDate */
function normalizePlatformFormat(platformFormat: string): string {
  const stripped = String(platformFormat ?? '')
    .trim()
    .replace(/'[^']*'/g, '')
  if (!stripped) return 'dd.MM.yyyy'
  return stripped
}

export function formatRecommendedDateTemplate(
  platformFormat: string,
  referenceDate: Date,
): string {
  const pattern = normalizePlatformFormat(platformFormat)
  return formatDate(referenceDate.toISOString(), pattern)
}

export function completePartialDateInput(
  inputText: string,
  platformFormat: string,
  referenceDate: Date,
  parseOpts?: ParsePageFieldToDateOptions,
): Date | null {
  const input = String(inputText ?? '').trim()
  if (!input || input.includes(MASK_PLACEHOLDER)) return null

  const recommended = formatRecommendedDateTemplate(platformFormat, referenceDate)
  if (input.length >= recommended.length) {
    return parsePageFieldToDate(input, parseOpts)
  }

  const completed = input + recommended.substring(input.length)
  return parsePageFieldToDate(completed, parseOpts)
}

export function createCurrentDateForPicker(pickerProps: DateTimePickerProps): Date {
  return new Date()
}

export type ResolveDateOnApplyCurrentDateClickParams = {
  modelValue: unknown
  inputText: string
  platformFormat: string
  pickerProps: DateTimePickerProps
}

/**
 * Swing JJDateChooser mouseClicked при applyCurrentDateOnClick:
 * каждый клик ставит текущие часы (повторный клик тоже обновляет).
 */
export function resolveDateOnApplyCurrentDateClick(
  params: ResolveDateOnApplyCurrentDateClickParams,
): Date {
  return createCurrentDateForPicker(params.pickerProps)
}

export function resolvePickerPropsFromPlatformFormat(
  platformFormat: string,
): DateTimePickerProps {
  return resolveDateTimePickerProps(platformFormat)
}
